module.exports = __webpack_public_path__ + "static/media/hero-works-one.27fde608.png";